import { UDFSnowflakeUser } from "@services/udf-api.service";
import { RequestState } from "../common/state";

export interface Statistics {
    domainQueries: any[];
    trendingSites: any[];
    sitesQueries: any[];
    businessUnitsQueries: any[];
}
export interface SnowflakeState {
    statisticsData: Statistics;
}
